import request from '../helpers/request';
import { thankYou } from './apiMapping';

/**
 * Save transaction data
 *
 * @param {object} formPayload
 * @returns {Promise}
 */
const postFormData = (formPayload) => request(thankYou.postFormData, formPayload, {method: 'post', timeout: 60000});


export { postFormData };